import {ComparisonResult} from "./ComparisonResult";

export const FinalReportComparisonUtils = {

	getComparisonStatusAction (name, otherName, costs, otherCosts, isOld) {
		if (!otherName) {
			return isOld ? ComparisonResult.removed : ComparisonResult.added;
		}

		if (JSON.stringify(costs) !== JSON.stringify(otherCosts) && name === otherName) {
			return ComparisonResult.changed;
		}

		if (JSON.stringify(costs) !== JSON.stringify(otherCosts) || name !== otherName) {
			return isOld ? ComparisonResult.changedOldVersion : ComparisonResult.changedNewVersion;
		}

		return ComparisonResult.same;
	},

	getComparisonStatusCost (
		name,
		otherName,
		costDivisionsProject,
		otherCostDivisionsProject,
		costDivisionsDocument,
		otherCostDivisionsDocument,
		isOld) {
		if (!otherName) {
			return isOld ? ComparisonResult.removed : ComparisonResult.added;
		}

		if (JSON.stringify(costDivisionsDocument) !== JSON.stringify(otherCostDivisionsDocument)
			|| JSON.stringify(costDivisionsProject) !== JSON.stringify(otherCostDivisionsProject)
			|| name !== otherName) {
			return isOld ? ComparisonResult.changedOldVersion : ComparisonResult.changedNewVersion;
		}

		return ComparisonResult.same;
	},

	getComparisonStatusSingleProperty (value, otherValue, isOld, otherExists) {
		if (!otherExists) {
			return isOld ? ComparisonResult.removed : ComparisonResult.added;
		}
		let propertiesDifferent = value !== otherValue;
		return propertiesDifferent ? ComparisonResult.changed : ComparisonResult.same;
	},

	propertiesDifferent (getter, value, otherValue) {
		if (!otherValue) {
			return true;
		}
		return getter(otherValue) !== getter(value);
	},

	calculateShade (shadeOffsetArg) {
		return ((shadeOffsetArg <= 0) ? " lighten-" : " darken-") + Math.abs(shadeOffsetArg);
	},

	comparisonColor (comparisonResult, shadeOffset) {

		switch (comparisonResult) {
			case ComparisonResult.removed:
				return "red" + this.calculateShade(shadeOffset);
			case ComparisonResult.added:
				return "green" + this.calculateShade(shadeOffset);
			case ComparisonResult.changedOldVersion:
				return "blue" + this.calculateShade(shadeOffset);
			case ComparisonResult.changedNewVersion:
				return "blue" + this.calculateShade(shadeOffset);
			case ComparisonResult.changed:
				return "blue" + this.calculateShade(shadeOffset);
			case ComparisonResult.same:
				return "grey" + this.calculateShade(shadeOffset + 3);

		}
	}

};